import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { ifDefined } from "lit/directives/if-defined.js";
import { getDummyText } from "../../utils";

export default {
    title: "Components/Interactive Tiles",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-interactive-tiles",
    args: {
        backgroundImageL:
            "https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/c/f/csm_Applications-image-picture_ce04ebee26.jpg",
        backgroundImageM: "",
        backgroundImageS:
            "https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/c/f/csm_Applications-image-picture_ce04ebee26.jpg",
        contentCentered: false,
        tiles: null,
    },
    argTypes: {
        backgroundImageL: { control: "text" },
        backgroundImageM: { control: "text" },
        backgroundImageS: { control: "text" },
        contentCentered: { control: "boolean" },
    },
};

const tiles3 = [
    {
        iconName: "",
        number: "",
        headline: getDummyText(30),
        copyText: getDummyText(300),
    },
    {
        iconName: "",
        number: "",
        headline: getDummyText(20),
        copyText: getDummyText(200),
    },
    {
        iconName: "",
        number: "",
        headline: getDummyText(32),
        copyText: getDummyText(350),
    },
];

const tiles4 = [
    {
        interactive: true,
        iconName: "avatar-technical-service",
        number: 1,
        headline: getDummyText(30),
        copyText: getDummyText(300),
    },
    {
        interactive: true,
        iconName: "financial-sales",
        number: 2,
        headline: getDummyText(20),
        copyText: getDummyText(200),
    },
    {
        interactive: true,
        iconName: "globe-fine",
        number: 3,
        headline: getDummyText(32),
        copyText: getDummyText(350),
    },
    {
        interactive: true,
        iconName: "application-laser-cutting",
        number: 4,
        headline: getDummyText(22),
        copyText: getDummyText(300),
    },
];

const Template = ({
    backgroundImageL,
    backgroundImageM,
    backgroundImageS,
    contentCentered,
    tiles,
}) =>
    html` <ux-iws-interactive-tiles
        content-centered="${contentCentered ? `true` : `false`}"
        background-image-s="${ifDefined(backgroundImageS)}"
        background-image-m="${ifDefined(backgroundImageM)}"
        background-image-l="${ifDefined(backgroundImageL)}"
    >
        ${tiles.map((tile) => {
            return html`
                <ux-iws-interactive-tile
                    interactive="${ifDefined(tile.interactive)}"
                    icon-name="${tile.iconName || ""}"
                    number="${tile.number || ""}"
                >
                    <div slot="headline" data-same-height="headline">
                        ${tile.headline}
                    </div>
                    <div slot="copy-text">
                        <p>
                            ${tile.copyText}
                        </p>
                    </div>
                    <div slot="link">
                        <a href="#" class="ux-text-link ux-text-link--green">
                            <span>Mehr erfahren</span>
                            <ux-icon name="arrow-small-right" />
                        </a>
                    </div>
                </ux-iws-interactive-tile>
            `;
        })}
    </ux-iws-interactive-tiles>`;

export const NonInteractive = Template.bind({});
NonInteractive.args = {
    tiles: tiles3,
};

export const Interactive = Template.bind({});
Interactive.args = {
    tiles: tiles4,
    contentCentered: true,
};
